export const WORK_UI_MODE_A = 'a'
export const WORK_UI_MODE_B = 'b'
export const WORK_ACTION_MODE_PREFERENCE_KEY = 'workActionMode'

export function normalizeWorkUiMode(value) {
  return value === WORK_UI_MODE_A ? WORK_UI_MODE_A : WORK_UI_MODE_B
}

export function nextWorkUiMode(value) {
  return normalizeWorkUiMode(value) === WORK_UI_MODE_A ? WORK_UI_MODE_B : WORK_UI_MODE_A
}

export function resolveWorkUiModes({ storedActionMode } = {}) {
  return {
    scrollMode: WORK_UI_MODE_A,
    actionMode: normalizeWorkUiMode(storedActionMode),
  }
}
